import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Bg from '../../Assets/images/pimg.png'

const ImageSlider = React.forwardRef(({ imageList }, ref) => {
  const settings = {
    dots: false,
    autoplay: false,
    infinite: true,
    speed: 1000,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div>
      <Slider ref={ref} {...settings}>
        {imageList.length > 0 ? (
          imageList.map((image, index) => (
            <div key={index}>
              <img src={image} alt={`Investment ${index}`} className="w-full h-64 object-cover rounded-lg" />
            </div>
          ))
        ) : (
          <div>
            <img src="" alt="image" className="w-full h-64 object-cover rounded-lg bg-gray-100" />
          </div>
        )}
      </Slider>
    </div>
  );
});

export default ImageSlider;